import AppLayout from '@/layout/AppLayout.vue'
const Agent = () => import('@/view/agent/Agent.vue')

const routes = {
  path: '/Agent',
  name: 'Agent',
  icon: 'icon-a-lianhe42',
  meta: {
    title: 'agent.agentMag'
  },
  component: Agent,
}

const components = {}

export default {
  routes,
  components,
}
